import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // <-- ✅ Need navigate
import "./LoginPage.css"; // Reuse your styling

function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate(); // <-- ✅

  const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      const res = await fetch("/auth/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (res.ok || res.status === 404) {
        setMessage("Password reset link sent to your email.");
        
        // ✅ Wait 3 seconds, then redirect
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } else {
        setError(data.error || "Something went wrong");
      }
    } catch {
      setError("Something went wrong");
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img
          src={`${process.env.PUBLIC_URL}/campwithfriends-logo.png`}
          alt="Camp With Friends Logo"
          style={{ width: "220px", marginBottom: "20px" }}
        />

        <h2>Reset your password</h2>
        <form onSubmit={handleSubmit} className="login-form">
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button
            type="submit"
            disabled={!isValidEmail(email)}
            style={{
              backgroundColor: isValidEmail(email) ? "#007bff" : "#ccc",
              color: "white",
              cursor: isValidEmail(email) ? "pointer" : "not-allowed",
            }}
          >
            Send reset link
          </button>
        </form>

        {message && <div className="success-text">{message}</div>}
        {error && <div className="error-text">{error}</div>}
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
